import { z } from 'zod';

export const optionalDateFromQuery = z
    .preprocess((v: unknown) => {
        if (v === undefined || v === null || v === '') return undefined;

        if (v instanceof Date) return v;

        if (typeof v === 'number') return new Date(v);

        if (typeof v === 'string') {
            const s = v.trim();

            if (/^[+-]?\d+$/.test(s)) {
                const ms = Number(s);
                return Number.isFinite(ms) ? new Date(ms) : v;
            }

            return new Date(s);
        }

        return v;
    }, z.date())
    .optional();
